<template lang="pug">
v-data-table.elevation-2.mt-4(
  :headers="headers",
  :items="questions",
  :loading="isLoading",
  loading-text="Loading... Please wait"
)
  template(v-slot:top="")
    v-toolbar(flat="", color="white")
      v-toolbar-title Questions
      v-spacer
      v-dialog(v-model="dialog", max-width="1000")
        template(v-slot:activator="{ on }")
          v-btn.mb-2(color="primary", dark="", v-on="on")
            v-icon(left) mdi-chat-plus
            | Add question
        v-card
          v-card-title
            span.headline {{ formTitle }}
          v-card-text
            v-container
              v-row
                v-col(md="4")
                  v-text-field(
                    v-model="editedItem.category",
                    label="Category",
                    outlined,
                    hide-details
                  )
                v-col(md="8")
                  v-text-field(
                    v-model="editedItem.title",
                    label="Title",
                    outlined,
                    hide-details
                  )
                v-col(md="4")
                  v-text-field(
                    v-model="editedItem.subtitle",
                    label="Subtitle",
                    outlined,
                    hide-details
                  )
                v-col(md="4")
                  v-text-field(
                    v-model="editedItem.info",
                    label="Info",
                    outlined,
                    hide-details
                  )
                v-col(md="4")
                  v-checkbox(
                    v-model="editedItem.is_looped",
                    label="Is looped?",
                    hide-details
                  )
              v-row(align="center")
                v-col(md="2")
                  span Answer blocks
                v-col(
                  md="6",
                  @click="editedItem.answer_blocks.push({ type: '' })"
                )
                  v-btn Add answer block
                v-col(
                  md="12",
                  v-for="(answer, index) in editedItem.answer_blocks",
                  :key="index"
                )
                  v-card
                    v-card-title 
                      v-row
                        v-col(cols="9") Answer block №{{ index + 1 }}
                        v-col(cols="1")
                          v-btn(
                            icon,
                            @click="moveAbUp(index)",
                            v-if="index != 0"
                          ) 
                            v-icon mdi-arrow-up-bold-box
                        v-col(cols="1")
                          v-btn(
                            icon,
                            @click="moveAbDown(index)",
                            v-if="index != editedItem.answer_blocks.length - 1"
                          ) 
                            v-icon mdi-arrow-down-bold-box
                        v-col(cols="1")
                          v-btn(
                            icon,
                            color="error",
                            @click="editedItem.answer_blocks = editedItem.answer_blocks.filter((v, ind) => ind != index)"
                          )
                            v-icon mdi-delete
                    v-card-text
                      v-row
                        v-col(md="6")
                          v-select(
                            v-model="answer.type",
                            label="Answer type",
                            :items="answerTypes",
                            outlined,
                            @change="changeAnswerType(answer, index)"
                          )
                        v-col(md="6")
                          v-text-field(
                            label="Alias",
                            outlined,
                            :error-messages="answer && answer.alias_error ? [answer.alias_error] : []",
                            v-model="answer.alias"
                          )
                      .mt-4
                        v-row(
                          v-if="answer.type == 'radio' || answer.type == 'checkbox'"
                        )
                          v-col(md="6")
                            v-btn(@click="addAnswerValue(answer)") Add value
                          v-col(md="3")
                            v-btn(@click="pasteValues(index, answer)") Paste
                          v-col(md="3")
                            v-btn(@click="pasteYesNo(index, answer)") Yes/No
                        v-row(
                          v-for="(value, i) in answer.values",
                          :key="i",
                          v-if="answer.type == 'radio' || answer.type == 'checkbox'",
                          align="center"
                        )
                          v-col(md="4")
                            v-text-field(
                              v-model="value.label",
                              label="Label",
                              outlined,
                              hide-details
                            )
                          v-col(md="4")
                            v-text-field(
                              v-model="value.value",
                              label="Value",
                              outlined,
                              hide-details
                            )
                          v-col(md="2")
                            v-text-field(
                              v-model="value.info",
                              label="Info",
                              outlined,
                              hide-details
                            )
                          v-col(cols="1")
                            v-btn(
                              icon,
                              @click="moveAvUp(index, i)",
                              v-if="i == answer.values.length - 1"
                            ) 
                              v-icon mdi-arrow-up-bold-box
                            v-btn(
                              icon,
                              @click="moveAvDown(index, i)",
                              v-if="i == 0"
                            ) 
                              v-icon mdi-arrow-down-bold-box

                          v-col(md="1")
                            v-btn(icon, @click="deleteAnswerValue(index, i)")
                              v-icon mdi-delete
                        v-row(
                          v-for="(value, i) in answer.values",
                          :key="i",
                          v-if="answer.type == 'input'"
                        )
                          v-col(md="6")
                            v-text-field(
                              v-model="value.label",
                              label="Label",
                              outlined,
                              hide-details
                            )
                          v-col(md="6")
                            v-text-field(
                              v-model="value.info",
                              label="Info",
                              outlined,
                              hide-details
                            )
                        v-row(
                          v-for="(value, i) in answer.values",
                          :key="i",
                          v-if="answer.type == 'date'"
                        )
                          v-col(md="6")
                            v-text-field(
                              v-model="value.label",
                              label="Label",
                              outlined,
                              hide-details
                            )
                          v-col(md="6")
                            v-text-field(
                              v-model="value.info",
                              label="Info",
                              outlined,
                              hide-details
                            )
                        v-row(
                          v-for="(value, i) in answer.values",
                          :key="i",
                          v-if="answer.type == 'autocomplete'"
                        )
                          v-col(md="4")
                            v-text-field(
                              v-model="value.label",
                              label="Label",
                              outlined,
                              hide-details
                            )
                          v-col(md="4")
                            v-text-field(
                              v-model="value.info",
                              label="Info",
                              outlined,
                              hide-details
                            )
                          v-col(md="4")
                            v-text-field(
                              v-model="value.url",
                              label="URL",
                              outlined,
                              hide-details
                            )
                        v-row(
                          v-for="(value, i) in answer.values",
                          :key="i",
                          v-if="answer.type == 'select'"
                        )
                          v-col(md="4")
                            v-text-field(
                              v-model="value.label",
                              label="Label",
                              outlined,
                              hide-details
                            )
                          v-col(md="4")
                            v-text-field(
                              v-model="value.info",
                              label="Info",
                              outlined,
                              hide-details
                            )
                          v-col(md="4")
                            v-select(
                              v-model="value.answer_select_items_id",
                              :items="selects",
                              item-text="name",
                              item-value="ID",
                              label="Items",
                              outlined,
                              hide-details
                            )
                          v-col(md="6")
                            v-text-field(
                              v-model="value.loop_answer_items_alias",
                              label="Loop answer items alias",
                              outlined,
                              hide-details
                            )
          v-card-actions
            v-spacer
            v-btn(color="primary", text="", @click="close") Cancel
            v-btn(color="primary", text="", @click="save") Save
  template(v-slot:item.actions="{ item }")
    v-icon.mr-2(small="", @click="editItem(item)")
      | mdi-pencil
    v-icon(small="", @click="deleteItem(item)")
      | mdi-delete
  template(v-slot:item.title="{ item }")
    span {{ item.title.length > 40 ? item.title.substring(0, 37) + '...' : item.title }}
  template(v-slot:item.a="{ item }")
    v-chip(
      color="error",
      v-if="item.answer_blocks.filter((v) => v.alias_error).length > 0"
    ) ERROR
</template>

<script>
export default {
  props: ["checks"],
  data: () => ({
    dialog: false,
    isLoading: false,
    headers: [
      { text: "ID", value: "ID" },
      { text: "Category", align: "start", value: "category" },
      { text: "Title", value: "title" },
      { text: "Alias errors", value: "a" },
      { text: "Actions", value: "actions" },
    ],
    answerTypes: [
      "radio",
      "input",
      "select",
      "autocomplete",
      "job-titles",
      "date",
      "checkbox",
    ],
    questions: [],
    editedIndex: -1,
    selects: [],
    editedItem: {
      category: "",
      title: "",
      is_looped: false,
      subtitle: "",
      info: "",
      nextOnAnswer: true,
      answer_blocks: [],
    },
    defaultItem: {
      category: "",
      title: "",
      is_looped: false,
      subtitle: "",
      info: "",
      nextOnAnswer: true,
      answer_blocks: [],
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.refreshQuestions();
    this.getSelects();
  },
  methods: {
    moveAvUp(abIndex, avIndex) {
      console.log("hi");
      let ab = this.editedItem.answer_blocks[abIndex];
      var z = ab.values[avIndex];
      ab.values[avIndex] = ab.values[avIndex - 1];
      ab.values[avIndex - 1] = z;
      this.$set(this.editedItem.answer_blocks, abIndex, ab);
    },
    moveAvDown(abIndex, avIndex) {
      console.log("hi");
      let ab = this.editedItem.answer_blocks[abIndex];
      var z = ab.values[avIndex];
      ab.values[avIndex] = ab.values[avIndex + 1];
      ab.values[avIndex + 1] = z;
      this.$set(this.editedItem.answer_blocks, abIndex, ab);
    },
    moveAbUp(index) {
      var z = this.editedItem.answer_blocks[index];
      this.$set(
        this.editedItem.answer_blocks,
        index,
        this.editedItem.answer_blocks[index - 1]
      );
      this.$set(this.editedItem.answer_blocks, index - 1, z);
    },
    moveAbDown(index) {
      var z = this.editedItem.answer_blocks[index];
      this.$set(
        this.editedItem.answer_blocks,
        index,
        this.editedItem.answer_blocks[index + 1]
      );
      this.$set(this.editedItem.answer_blocks, index + 1, z);
    },
    deleteAnswerValue(answerBlockIndex, answerValueIndex) {
      this.editedItem.answer_blocks[answerBlockIndex].values.splice(
        answerValueIndex,
        1
      );
    },
    pasteYesNo(ind, ans) {
      ans.values = [
        { label: "Yes", value: "true", info: "" },
        { label: "No", value: "false", info: "" },
      ];
    },
    pasteValues(ind, ans) {
      navigator.clipboard
        .readText()
        .then((text) => {
          ans.values = text
            .split(",,")
            .map((v) => ({ label: v.trim(), value: v.trim(), info: "" }));
        })
        .catch((err) => {
          this.$message.error("Failed to read clipboard contents: " + err);
        });
    },
    getSelects() {
      this.axios.get("/admin/selects").then((resp) => {
        this.selects = resp.data;
      });
    },
    addAnswerValue(ans) {
      switch (ans.type) {
        case "radio":
          ans.values.push({ label: "", value: "", info: "" });
          break;
        case "checkbox":
          ans.values.push({ label: "", value: "", info: "" });
          break;
      }
    },
    changeAnswerType(val, index) {
      switch (val.type) {
        case "radio":
          this.$set(
            this.editedItem.answer_blocks,
            index,
            Object.assign({}, { type: "radio", alias: "", values: [] })
          );
          break;
        case "checkbox":
          this.$set(
            this.editedItem.answer_blocks,
            index,
            Object.assign({}, { type: "checkbox", alias: "", values: [] })
          );
          break;
        case "input":
          this.$set(
            this.editedItem.answer_blocks,
            index,
            Object.assign(
              {},
              { type: "input", alias: "", values: [{ label: "", info: "" }] }
            )
          );
          break;
        case "date":
          this.$set(
            this.editedItem.answer_blocks,
            index,
            Object.assign(
              {},
              { type: "date", alias: "", values: [{ label: "", info: "" }] }
            )
          );
          break;
        case "autocomplete":
          this.$set(
            this.editedItem.answer_blocks,
            index,
            Object.assign(
              {},
              {
                type: "autocomplete",
                alias: "",
                values: [{ label: "", info: "", url: "" }],
              }
            )
          );
          break;
        case "select":
          this.$set(
            this.editedItem.answer_blocks,
            index,
            Object.assign(
              {},
              {
                type: "select",
                alias: "",
                values: [
                  {
                    label: "",
                    info: "",
                    answer_select_items_id: 0,
                    loop_answer_items_alias: "",
                  },
                ],
              }
            )
          );
          break;
      }
    },
    refreshQuestions() {
      this.isLoading = true;
      this.axios
        .get("/admin/question")
        .then((resp) => {
          this.questions = resp.data;
        })
        .catch((e) => {
          this.$message.errorFromServer(e);
        })
        .finally(() => (this.isLoading = false));
    },

    editItem(item) {
      this.editedIndex = this.questions.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.questions.indexOf(item);
      if (confirm("Are you sure you want to delete this item?")) {
        this.questions.splice(index, 1);
        this.axios.delete("/admin/question" + item.ID);
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedItem.answer_blocks = [];
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.questions[this.editedIndex], this.editedItem);
        var newItem = Object.assign({}, this.questions[this.editedIndex]);
        delete newItem.UpdatedAt;
        delete newItem.CreatedAt;
        this.axios
          .put("/admin/question", newItem)
          .then(() => {
            this.editedItem = this.defaultItem;
            this.close();
          })
          .catch((e) => {
            this.$message.errorFromServer(e);
          });
      } else {
        this.axios
          .post("/admin/question", this.editedItem)
          .then(() => {
            this.refreshQuestions();
            this.close();
          })
          .catch((e) => {
            this.$message.errorFromServer(e);
          });
      }
    },
  },
};
</script>